let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3kHns"), load("3JzPO"), load("4pYLw")]).then(() => parcelRequire('i9E8j'));